<template>
    <div class="ding-container">
<!-- H5微任务 -->
        <el-card class="h5-card">
            <div slot="header">
                <span class="title">H5微应用</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="editH5Base = true" icon="el-icon-edit-outline" v-if="!editH5Base"></el-button>
                <el-button style="float: right; padding: 3px 0" type="text" @click="saveH5Btn" icon="el-icon-finished" v-else></el-button>
            </div>
            <el-form ref="dingTalkForm" :model="h5Data" label-width="150px">
                <el-form-item label="应用名称：">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editH5Base" @click="copy(h5Data.name)" style="cursor: pointer">{{ h5Data.name }}</span>
                        <el-input v-model="h5Data.name" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="凭据(AgentId)：">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editH5Base" @click="copy(h5Data.agent_id)" style="cursor: pointer">{{ h5Data.agent_id }}</span>
                        <el-input v-model="h5Data.agent_id" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="AppKey：">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editH5Base" @click="copy(h5Data.app_key)" style="cursor: pointer">{{ h5Data.app_key }}</span>
                        <el-input v-model="h5Data.app_key" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="凭据(AppSecret)：">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editH5Base" @click="copy(h5Data.app_secret)" style="cursor: pointer">{{ h5Data.app_secret }}</span>
                        <el-input v-model="h5Data.app_secret" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="订阅加密(aes_key)：">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editH5Base" @click="copy(h5Data.aes_key)" style="cursor: pointer">{{ h5Data.aes_key }}</span>
                        <el-input v-model="h5Data.aes_key" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="订阅签名(token)：">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editH5Base" @click="copy(h5Data.token)" style="cursor: pointer">{{ h5Data.token }}</span>
                        <el-input v-model="h5Data.token" v-else></el-input>
                    </el-tooltip>
                </el-form-item>

                <el-tooltip content="点击复制" placement="bottom">

                </el-tooltip>
            </el-form>
        </el-card>
<!--        扫码登录-->
        <el-card class="scanLogin-card">
            <div slot="header">
                <span class="title">扫码登录</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="editScanBase = true" icon="el-icon-edit-outline" v-if="!editScanBase"></el-button>
                <el-button style="float: right; padding: 3px 0" type="text" @click="saveScanLoginBtn" icon="el-icon-finished" v-else></el-button>
            </div>
            <el-form ref="dingTalkForm" :model="scanLoginData" label-width="130px">
                <el-form-item label="应用名称:">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editScanBase" @click="copy(scanLoginData.name)" style="cursor: pointer">{{scanLoginData.name}}</span>
                        <el-input v-model="scanLoginData.name" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="凭据(AppSecret):">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editScanBase" @click="copy(scanLoginData.app_secret)" style="cursor: pointer">{{scanLoginData.app_secret}}</span>
                        <el-input v-model="scanLoginData.app_secret" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="移动应用ID:">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editScanBase" @click="copy(scanLoginData.app_id)" style="cursor: pointer">{{scanLoginData.app_id}}</span>
                        <el-input v-model="scanLoginData.app_id" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="回调域名:">
                    <el-tooltip content="点击复制" placement="bottom">
                        <span v-if="!editScanBase" @click="copy(scanLoginData.redirect_uri)" style="cursor: pointer">{{scanLoginData.redirect_uri}}</span>
                        <el-input v-model="scanLoginData.redirect_uri" v-else></el-input>
                    </el-tooltip>
                </el-form-item>
            </el-form>
        </el-card>
    </div>
</template>

<script>
  import {dingtalkH5List,saveDingTalkH5,scanLoginList,saveDingTalkScanLogin} from '@/api/dingTalk'
  export default {
    name: 'dingSetting',
    data(){
      return{
        h5Data:{},
        scanLoginData:{},
        editH5Base:false,
        editScanBase:false,
      }
    },
    created(){
      this.getH5Data()
      this.getScanLoginData()
    },
    methods:{
      // 获取 H5微应用 信息
      getH5Data(){
        dingtalkH5List().then(res => {
          this.h5Data = res.model
        })
      },
      //保存 H5信息
      saveH5Btn(){
        saveDingTalkH5(this.h5Data).then(res => {
          if(res.code !==100000){
            return this.$message.error('保存失败')
          }
          this.editH5Base = false
          this.getH5Data()
          this.$message.success('保存成功')
        })
      },
      //获取 扫码登录 信息
      getScanLoginData(){
        scanLoginList().then(res => {
          this.scanLoginData = res.model
        })
      },
      //保存 扫码登录 信息
      saveScanLoginBtn(){
        saveDingTalkScanLogin(this.scanLoginData).then(res => {
          if(res.code !== 100000){
            return this.$message.error('保存失败')
          }
          this.editScanBase = false
          this.getScanLoginData()
          this.$message.success('保存成功')
        })
      },

      //点击复制文本
      copy(item) {
        // 模拟 输入框
        const cInput = document.createElement("input");
        cInput.value = item;
        document.body.appendChild(cInput);
        cInput.select(); // 选取文本框内容

        // 执行浏览器复制命令
        // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
        // Input要在正常的编辑状态下原生复制方法才会生效

        document.execCommand("copy");

        this.$message({
          type: "success",
          message: "复制成功"
        });
        // 复制成功后再将构造的标签 移除
        document.body.removeChild(cInput);
      }

    }
  }
</script>

<style scoped>
    .ding-container{
        display: flex;
    }
    .h5-card{
    width: 720px;
        margin-right: 50px;
    }
    .scanLogin-card{
        width: 720px;
    }
    .ding-container{
        margin-top: 20px;
        margin-left: 20px;
    }
    .title{
        font-size: 18px;
    }
    .body-box{
        text-align: left;
        font-size: 12px;
    }

</style>